module.exports = __webpack_public_path__ + "img/54.f10baf30.png";